<template>
    <div class='box'>
        <div class="title">白条账单【{{detailsId}}】</div>
        <div class="list">
            <div>
                <el-tooltip class="item" effect="dark" content="订单号" placement="top">
                    <span>订单号：</span>
                </el-tooltip>
                {{detalisList.orderNumber}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="消费金额" placement="top">
                    <span>消费金额：</span>
                </el-tooltip>{{detalisList.amount}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="描述" placement="top">
                    <span>描述：</span>
                </el-tooltip>
                {{detalisList.remark}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="创建时间" placement="top">
                    <span>创建时间：</span>
                </el-tooltip>
                {{detalisList.createDime}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="支付时间" placement="top">
                    <span>支付时间：</span>
                </el-tooltip>
                {{detalisList.payTime}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="支付状态" placement="top">
                    <span>支付状态：</span>
                </el-tooltip>
                {{detalisList.payStatus?"已付款":"未付款"}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="分期" placement="top">
                    <span>分期(天)：</span>
                </el-tooltip>
                {{detalisList.installmentDays}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="利率" placement="top">
                    <span>利率(%/天)：</span>
                </el-tooltip>
                {{detalisList.rate}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="实际还款总额" placement="top">
                    <span>实际还款总额：</span>
                </el-tooltip>
                {{detalisList.realPayment || 0}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="还款状态" placement="top">
                    <span>还款状态：</span>
                </el-tooltip>
                {{getmouseStatus(detalisList.status)}}
            </div>
            <div>
                <el-tooltip class="item" effect="dark" content="还款日期" placement="top">
                    <span>还款日期：</span>
                </el-tooltip>
                {{detalisList.repaymentTime}}
            </div>
        </div>
        <div class="repaymentList" v-if="!detalisList.payStatus">
            <div @click="getPayment(0)">
                立即还款(线下支付)
            </div>
            <div @click="getPayment(1)">
                立即还款(在线支付)
            </div>
        </div>
    </div>
</template>
<script>
import { getDetails } from '@/api/xunyou'

export default {
    data() {
        return {
            detailsId:this.$route.query.detailsId,
            detalisList:''
        }
    },
    created(){
        this.getDetail()
    },
    methods: {
        getPayment(val) {
            this.$router.push('/payment?usid='+val+'&detailsId='+this.detailsId)
        },
        getDetail(){
            getDetails({detailsId:this.detailsId}).then(res=>{
                console.log(res,'ressssss')
                this.detalisList = res.data
            })
        },
        
        getmouseStatus(val) {
            switch (val) {
                case 0:
                    return '待还款';
                    break;
                case 1:
                    return '已还款';
                    break;
                case 2:
                    return '已逾期';
                    break;
            }
        },
    }
}
</script>
<style scoped lang="less">
.box {
    padding: 10px 0;
}

.title {
    font-size: 30px;
    font-weight: 400;
    line-height: 68px;
    color: #757575;
    border-bottom: 1px solid #eaeaea;
}

.list {
    font-size: 14px;

    div {
        margin-top: 20px;

        span {
            display: inline-block;
            width: 140px;
        }
    }
}

.repaymentList {
    display: flex;
    margin-top: 10px;

    div {
        color: #fff;
        background-color: #ff6700;
        border-color: #e65d00;
        width: 160px;
        font-size: 12px;
        padding: 5px 5px;
        text-align: center;
        line-height: 23px;
        margin-right: 17px;
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/stripeDetails.vue